import * as geom from "js/core/utilities/geom";
import { CollectionElement } from "js/elements/base/CollectionElement";
import { _ } from "js/vendor";
import ConnectorItem from "./ConnectorItem";

export default class ConnectorGroup extends CollectionElement {
    getChildItemType() {
        return ConnectorItem;
    }

    get minItemCount() {
        return 0;
    }

    getTargetElement(id) {
        if (id.contains("/")) {
            return this.canvas.getElementByUniquePath(id);
        } else {
            return this.parentElement.elements[id];
        }
    }

    get connectors() {
        if (!this._connectors) {
            this._connectors = [];
        }
        return this._connectors;
    }

    get startPointsAreLocked() {
        return _.defaultTo(this.options.startPointsAreLocked, false);
    }

    get endPointsAreLocked() {
        return _.defaultTo(this.options.endPointsAreLocked, false);
    }

    get canDeleteConnectors() {
        return _.defaultTo(this.options.canDeleteConnectors, true);
    }

    get canAddLabels() {
        return _.defaultTo(this.options.canAddLabels, true);
    }

    getConnectorsForItem(itemId, type) {
        if (type == "source") {
            return this.itemElements.filter(connector => connector.model.source == itemId);
        } else {
            return this.itemElements.filter(connector => connector.model.target == itemId);
        }
    }

    addConnector(options) {
        this.addItem(options);
    }

    setupElement() {
        this.containerElement = this.options.containerElement;
    }

    _calcProps(props, options) {
        let { size } = props;

        for (let item of this.itemElements) {
            let itemProps = item.calcProps(size, { shape: options.shape });
            itemProps.bounds = new geom.Rect(0, 0, size);
        }

        return { size };
    }

    removeElement(element) {
        if (element instanceof ConnectorItem && element.animator) {
            element.animator.stop();
            element.animator = null;
        }

        return super.removeElement(element);
    }
}
